<nav class="bg-gray-800 dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-gray-200 dark:border-gray-600">
    <div class="flex flex-wrap items-center justify-between mx-auto p-4">
        <div class="lg:hidden">
            <button nz-button nz-dropdown [nzDropdownMenu]="menuDesp" nzPlacement="bottomRight" nzTrigger="click"
                class="w-10 h-10 justify-center text-sm lg:hidden">
                <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                    <path stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M1 1h15M1 7h15M1 13h15" />
                </svg>
            </button>

            <nz-dropdown-menu #menuDesp="nzDropdownMenu">
                <app-menu [countPauses]="countPauses"></app-menu>
            </nz-dropdown-menu>
        </div>
        <div class="flex flex-wrap">
            <a routerLink="/production-orders" class="flex items-center space-x-3 rtl:space-x-reverse">
                <div class="flex items-center lg:pr-4 lg:border-r border-gray-500 h-full">
                    <img class="w-3 h-auto mr-2" src="assets/svg/devoltec-logo.svg" alt="Devoltec Logo"
                        loading="lazy" />
                    <span
                        class="text-[15px] self-center text-2xl font-semibold whitespace-nowrap text-gray-50">MES</span>
                </div>
            </a>

            <div class="items-center justify-start hidden w-full lg:flex lg:w-auto lg:order-1" id="navbar-sticky">
                <app-menu [nzMode]="'horizontal'" [class]="'custom-menu'" [countPauses]="countPauses"></app-menu>
            </div>
        </div>

        <div class="flex lg:order-2 space-x-3 lg:space-x-0 rtl:space-x-reverse">
            <div class="flex pr-4 items-center border-r border-gray-500 hidden lg:inline-flex">
                <p class="text-white font-medium">v.{{ version }}</p>
            </div>
            @if (loggedScreen) {
            <div class="flex items-center text-white font-normal text-[13px] pl-4 pr-4 border-r border-gray-500">
                <span class="font-semibold">Pantalla:</span>&nbsp;&nbsp;{{
                loggedScreen.name
                }}
            </div>
            }

            <div class="pl-4 dropdown dropdown-end">
                <div class="relative inline-block text-left">
                    <app-dropdown-user></app-dropdown-user>
                </div>
            </div>
        </div>
    </div>
</nav>
